import { useParams, Link, useNavigate } from 'react-router-dom';
import { spicesData, getSpiceById, categoryLabels } from '../data/spicesData';
import { ChevronRight, ChevronDown, Leaf, Globe, Utensils, Languages, MessageSquareQuote } from 'lucide-react';
import { useState } from 'react';

// AI-Generated high-resolution images for spices (detail page)
const spiceImages = {
  'pepper': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/bacaa420d54ecd180b568d53bd2aea3f8873489bf9b061609045bfefaa09aad8.png',
  'cardamom': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/52c3a55bace244d3817552b61258569c410fe1b41b18a3d401f0cff4cdc59d03.png',
  'turmeric': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b4f9acf2d3a5e29d42243d3c64259f4d3666d82e61cd28666660865f8c2c1743.png',
  'cumin': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/6337f1a59d9898558c0b27f8f71ca2fd169854de1e9e36f4ab325ebc94606448.png',
  'chilli': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/cd7bf10b93e367d98fd980623167a68ad1f9fcf58fa8ce62b8e8f113e3db3bd8.png',
  'ginger': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/1dcfe17eb451e705ad21722ca66f204b3271e3e878b0b5893f2f5b08b2aa1d70.png',
  'coriander': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/ef13192878c6bf66a0bf12a872a4dd0a4e7f088ddfd4c62dabf757fb7d6ba083.png',
  'cinnamon': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e5790e42d1fdede6623e596e1bfe9da7c1531596126cb2de92fe127261e49fc8.png',
  'clove': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/0dd77a03fa329223230c2735d92704149f8993f9da4edf7a82ef92bc3b64b109.png',
  'nutmeg': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b9e6d7e4522a21c51889e22dc78ea3b85e5b49cc4d3a1d8d8f1dbd248fb97d63.png',
  'fennel': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/09a68a0c9baef46182bf33a227eef140ceb93d08a77218d2c6319f7161ea2126.png',
  'fenugreek': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/6c76ff508c918b83da08c8a8aeca13d5d968a62f48f4d28a1e732b52905acc73.png',
  'mustard': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b8cfa0fcc5228ade5d3ea2bd97b0f318977139dd40a73e7179fbe49b2d52a727.png',
  'saffron': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b4a23db5a4efd82793833dbc7bd64f3a2b6bd5fd0f678ea045b6b92494e11fd4.png',
  'vanilla': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/bdc400832b37691624b43c054952b1a02322cd429e352067af9069f7de091200.png',
  'star-anise': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/5f21389f593c7a5b43d1d9d7b46078a24979171ed50ce2b9c167678e4101405a.png',
  'bay-leaf': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/a44330b08c3a25061e34484c333795b28025acef2b23a1115bc911f88048e789.png',
  'asafoetida': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/ecb2724f24b7e1301aabdff3966d242c0362e93940d6a6639f217a84be0e831a.png',
  'tamarind': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/63ae732e7d7abf482e52d9f2511a1439ca8e535068ea7354a51aff974de84809.png',
  'curry-leaf': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/aa442e84982b5462c9dacbc0b19d7fbc0fcec6c0888d6af5b3bc573d2d86d54f.png',
  'garlic': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/eace987d5691cc46e8a49203ccf9b8e91d8f804c76fc486dee6610eda4fc5344.png',
  'poppy-seed': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e8b6a959ecaa1a4e1f0abe8c3af72f5f13bb897e94859002465db96df09eb600.png',
  'caraway': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/749130c7b08968a0f797f9740572057e90844748c3501478f4683b600c2ae795.png',
  'celery': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/6e078f70484569e91fb55105aee52c9c251efb91ab7708ac3132f14b468d2130.png',
  'dill': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/3027a533dbfa3a9f84c5c81f33e7dc3c7fc9034e4fb08dc7719a43204f5a9f64.png',
  'sesame': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/088419eda964fc4498d87edafc6778d9670d0a47e43fcbfaaee892268eadfa64.png',
  'ajwain': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/23bd69d4db6601f4febaa7bbd6b621a72d1a96ba2067311b8d15b5d16ad96318.png',
  'nigella': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b9567efdddc9641c0da289c8b72b015018309eb95c7b0366f524a053feebca92.png',
  'kokum': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/96a7c502009f9536d7d445b97f0457c756cb460aa06c8a130c226d853602f749.png',
  'aniseed': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/50a78fcfe7eea90a892d1f58274dd35d90b19a4f5f37b1b1f4ec27ffec99dc80.png',
  'cardamom-large': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/cfb1d0808668198f5b90e9a3c5e01b9582625346d9dcbe5ff1756dddde88edef.png',
  'cassia': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e4808bffbaac36e53531dbfb2493f3c5d7325e4515c6298224d6f9d0e9d41e9b.png',
  'allspice': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/3a6679e8509c03696195862be64fc7d8643c7de73162e12dcf772a020a69e8b2.png',
  'basil': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/90580c709132ff0c1269f082dd4e7646adcc03cd8059aee218ddec1782360c88.png',
  'cambodge': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/cf6f7bafe5768272524ac0af10c58197f2714e58a87f9316b0077720c5592136.png',
  'caper': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/cca33e9dd207fee4683a12f93c8a4e58e561b6b121726d5fcfde49954731e67e.png',
  'galangal': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/8a54797b1b3133c327b7697dd8481500e0f8b0c6666814bd40cab9c6f71c7257.png',
  'horseradish': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/7f7039871f6bc90c4f06e425e919133f1486abf0401b218439655d4346c258f4.png',
  'hyssop': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/bd49ba9c0f2b9d0933ee79dcd3eb96c8c8ba80ceca5070d3562740cdb59db9d1.png',
  'juniper': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/28e6e32d34f207c813d7d89a5d269c4842e3faab8348d001b329c9103956ab07.png',
  'lovage': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/771e5724a33c0558dd77ceadd271c18e2fa4409d37d685b012f81f99673edc74.png',
  'marjoram': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/09372703f0c332978d33f4d2c83db37ea2faad45c9288540f53f123454e242ee.png',
  'mint': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/2e7c6d4303e395daa3e3fcb0f2495b020aaa6f77bb7c8076328e7b6564b18ad5.png',
  'oregano': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/3b9b9a62094bbc0d5559eead58208f87c02326908659aff6fca48a5b78f63a4b.png',
  'parsley': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/64d398dfe147f4fb94f2f2144c19a7e07675a7b9c3807964dd19b920627bbcbd.png',
  'long-pepper': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/5ef52c333943b412f535fa0effc4ce43091a082ea6038d4f96f51d9f6c493fee.png',
  'pomegranate': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/1354c5f77663b76f2b25fa927ae5a8fa4234b170dad4cc61fb9162381d7849ae.png',
  'rosemary': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e908558f605dc578bb1f5fb5fb43f2437e6bee74c58fb77f39c557d9b5c5bc31.png',
  'sage': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/66e14c00677dcfe451d5592af0b73ac6cfc6ad9f7a7fc938e753cbba0ad838e6.png',
  'sweet-flag': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/62c8a291a5154c9942aa41752b05a57520ad51c7e3aabf34c19b3d2733069fea.png',
  'tarragon': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e051549b6206d46e6b9757da9b9bbe81e599a44181452be6afc2f2c5d8cc0d50.png',
  'tejpat': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/56df4ee06cbc8584d50e31a626533ebf52ed27750d95129ac3af05386fd3e88a.png',
  'thyme': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e4ebdb62688d54f6318d2c0f3d73b11a003ca1a555be16426e9bc0b74b578866.png',
};

const getSpiceImage = (imageKey) => {
  return spiceImages[imageKey] || 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=800&h=500&fit=crop';
};

export default function SpiceDetail() {
  const { spiceId } = useParams();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const spice = getSpiceById(spiceId);

  if (!spice) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-700 mb-4">Spice Not Found</h1>
          <Link to="/products/spices" className="text-[#F47D20] hover:underline">
            Return to Spice Catalogue
          </Link>
        </div>
      </div>
    );
  }

  const handleSpiceChange = (newSpiceId) => {
    setIsDropdownOpen(false);
    navigate(`/products/spices/${newSpiceId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#263776] via-[#1e2d5f] to-[#263776] text-white">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl translate-x-1/2 -translate-y-1/2"></div>
        </div>
        <div className="container mx-auto px-4 py-8 relative z-10">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm mb-6 text-gray-300">
            <Link to="/" className="hover:text-[#F47D20] transition-colors">Home</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products" className="hover:text-[#F47D20] transition-colors">Products</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products/spices" className="hover:text-[#F47D20] transition-colors">Spice Catalogue</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-[#F47D20]">{spice.name}</span>
          </nav>

          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Image */}
            <div className="w-full lg:w-1/2">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={getSpiceImage(spice.image)}
                  alt={spice.name}
                  className="w-full h-64 md:h-80 object-cover"
                />
                <div className="absolute top-4 right-4 px-3 py-1.5 bg-[#F47D20] text-white text-sm font-medium rounded-full">
                  {categoryLabels[spice.category]}
                </div>
              </div>
            </div>

            {/* Title and Quick Info */}
            <div className="w-full lg:w-1/2">
              {/* Spice Dropdown Selector */}
              <div className="relative mb-6">
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="flex items-center justify-between w-full md:w-80 px-4 py-3 bg-white/10 backdrop-blur border border-white/20 rounded-lg text-left hover:bg-white/20 transition-colors"
                  data-testid="spice-dropdown-toggle"
                >
                  <span className="text-sm">Browse Other Spices</span>
                  <ChevronDown className={`w-5 h-5 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-full md:w-80 max-h-64 overflow-y-auto bg-white rounded-lg shadow-xl z-50 border border-gray-200">
                    {spicesData.map((s) => (
                      <button
                        key={s.id}
                        onClick={() => handleSpiceChange(s.id)}
                        className={`w-full px-4 py-2.5 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between ${
                          s.id === spice.id ? 'bg-[#F47D20]/10 text-[#F47D20]' : 'text-gray-700'
                        }`}
                      >
                        <span>{s.name}</span>
                        {s.id === spice.id && <span className="text-xs">Current</span>}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <h1 className="text-4xl md:text-5xl font-bold mb-2">{spice.name}</h1>
              <p className="text-xl text-gray-300 italic mb-6">{spice.botanicalName}</p>
              
              {/* Quick Info Cards */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-white/10 backdrop-blur rounded-lg p-4">
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">Family</div>
                  <div className="font-semibold">{spice.family}</div>
                </div>
                <div className="bg-white/10 backdrop-blur rounded-lg p-4">
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">Commercial Part</div>
                  <div className="font-semibold">{spice.commercialPart}</div>
                </div>
              </div>

              {/* Get Quote Button */}
              <Link
                to={`/contact?spice=${encodeURIComponent(spice.name)}&type=Quote%20Request`}
                className="inline-flex items-center px-6 py-3 bg-[#F47D20] text-white font-semibold rounded-lg hover:bg-[#e06d10] transition-colors shadow-lg"
                data-testid="get-quote-btn"
              >
                <MessageSquareQuote className="w-5 h-5 mr-2" />
                Get Quote for {spice.name}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8">
            {/* Description */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#263776]/10 rounded-lg flex items-center justify-center">
                  <Leaf className="w-5 h-5 text-[#263776]" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Description</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{spice.description}</p>
            </section>

            {/* Origin and Distribution */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#F47D20]/10 rounded-lg flex items-center justify-center">
                  <Globe className="w-5 h-5 text-[#F47D20]" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Origin & Distribution</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{spice.origin}</p>
            </section>

            {/* Uses */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <Utensils className="w-5 h-5 text-green-600" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Uses</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{spice.uses}</p>
            </section>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Indian Names */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                  <Languages className="w-5 h-5 text-purple-600" />
                </div>
                <h2 className="text-lg font-bold text-[#263776]">Indian Names</h2>
              </div>
              <div className="space-y-2">
                {Object.entries(spice.indianNames).map(([lang, name]) => (
                  <div key={lang} className="flex justify-between py-2 border-b border-gray-100 last:border-0">
                    <span className="text-gray-500 text-sm">{lang}</span>
                    <span className="font-medium text-gray-800 text-sm">{name}</span>
                  </div>
                ))}
              </div>
            </section>

            {/* Foreign Names */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Globe className="w-5 h-5 text-blue-600" />
                </div>
                <h2 className="text-lg font-bold text-[#263776]">International Names</h2>
              </div>
              <div className="space-y-2">
                {Object.entries(spice.foreignNames).map(([lang, name]) => (
                  <div key={lang} className="flex justify-between py-2 border-b border-gray-100 last:border-0">
                    <span className="text-gray-500 text-sm">{lang}</span>
                    <span className="font-medium text-gray-800 text-sm">{name}</span>
                  </div>
                ))}
              </div>
            </section>

            {/* CTA Card */}
            <div className="bg-gradient-to-br from-[#263776] to-[#1e2d5f] rounded-xl p-6 text-white">
              <h3 className="text-lg font-bold mb-3">Interested in {spice.name}?</h3>
              <p className="text-gray-300 text-sm mb-4">
                Get competitive pricing and custom specifications for your business needs.
              </p>
              <Link
                to={`/contact?spice=${encodeURIComponent(spice.name)}&type=Quote%20Request`}
                className="block w-full py-3 bg-[#F47D20] text-center font-semibold rounded-lg hover:bg-[#e06d10] transition-colors"
                data-testid="sidebar-get-quote-btn"
              >
                Request Quote
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Related Spices */}
      <div className="bg-gray-100 py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-[#263776] mb-6">Other Spices You May Like</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {spicesData
              .filter(s => s.id !== spice.id && s.category === spice.category)
              .slice(0, 6)
              .map((relatedSpice) => (
                <Link
                  key={relatedSpice.id}
                  to={`/products/spices/${relatedSpice.id}`}
                  className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all"
                >
                  <div className="h-24 overflow-hidden">
                    <img
                      src={getSpiceImage(relatedSpice.image)}
                      alt={relatedSpice.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-3">
                    <h3 className="font-medium text-sm text-[#263776] group-hover:text-[#F47D20] transition-colors truncate">
                      {relatedSpice.name}
                    </h3>
                  </div>
                </Link>
              ))}
          </div>
          
          <div className="text-center mt-8">
            <Link
              to="/products/spices"
              className="inline-flex items-center px-6 py-3 border-2 border-[#263776] text-[#263776] font-semibold rounded-lg hover:bg-[#263776] hover:text-white transition-colors"
            >
              View Full Catalogue
              <ChevronRight className="w-5 h-5 ml-2" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
